  <template>
  <div>
    <!-- web -->
    <nav
      :class="['navbar', 'navbar-expand-lg', comClass, viewScroll_status]"
      class="hidden-sm-and-down"
    >
      <div class="navbar-brand hidden-sm-and-down" @click="navgo('home')">
        <img
          class="login-img"
          :src="
            '/static/link/img/home/' +
            (comClass == 'BCnav' || windowSIZE.screenWidth < 1000
              ? 'logo2_img.png'
              : 'logo1_img.png')
          "
          alt="德卡"
        />
        <!-- <span></span> -->
      </div>
      <div class="navbar-brand visible-sm-and-down" @click="navgo('home')">
        <img
          class="login-img"
          :src="
            '/static/link/img/home/' +
            (comClass == 'BCnav' || windowSIZE.screenWidth < 1000
              ? 'logo2_img.png'
              : 'logo1_img.png')
          "
          alt="德卡"
        />
        <!-- <span></span> -->
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="el-icon-menu"></span>
        <!-- <span class="el-icon-close" v-if="!navMenuShow"></span> -->
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto" v-if="navMenuShow">
          <li class="nav-item">
            <a
              :class="['nav-link', $route.path == '/' ? 'active-nav' : '']"
              @click="navgo('home')"
              v-if = "this.isEn != '1'"
            >
              首页
            </a>
            <a
              :class="['nav-link', $route.path == '/' ? 'active-nav' : '']"
              @click="navgo('home')"
              v-if = "this.isEn == '1'"
            >
              Home Page
            </a>
          </li>
          <li
            class="nav-item"
            style="position: relative"
            @click="navPhonego(windowSIZE.screenWidth)"
            @mouseover="Mover"
            @mouseleave="Mout"
          >
            <!-- <li class="nav-item" style="position: relative;" @mouseover="Mover"  @mouseleave="Mout"> -->
            <!-- @click="navgo('product')" -->
            <a
              :class="[
                'nav-link',
                'hover-nav-item',
                $route.path.startsWith('/mobileScene') ||
                $route.path.startsWith('/productinfo')
                  ? 'active-nav'
                  : '',
              ]"
              v-if = "this.isEn != '1'"
              >产品与方案</a
            >
            <a
              :class="[
                'nav-link',
                'hover-nav-item',
                $route.path.startsWith('/mobileScene') ||
                $route.path.startsWith('/productinfo')
                  ? 'active-nav'
                  : '',
              ]"
              v-if = "this.isEn == '1'"
            >Products and Solutions</a
            >
            <!-- <a :class="['nav-link','hover-nav-item']">产品与方案</a> -->
          </li>
          <li class="nav-item">
            <a
              :class="[
                'nav-link',
                $route.path == '/service' ? 'active-nav' : '',
              ]"
              @click="navgo('service')"
              v-if = "this.isEn != '1'"
              >服务支持</a
            >
            <a
              :class="[
                'nav-link',
                $route.path == '/service' ? 'active-nav' : '',
              ]"
              @click="navgo('service')"
              v-if = "this.isEn == '1'"
            >Services and Supports</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="['nav-link', $route.path == '/news' ? 'active-nav' : '']"
              @click="navgo('news')"
              v-if = "this.isEn != '1'"
              >新闻动态</a
            >
            <a
              :class="['nav-link', $route.path == '/news' ? 'active-nav' : '']"
              @click="navgo('news')"
              v-if = "this.isEn == '1'"
            >News and Trends</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="['nav-link', $route.path == '/about' ? 'active-nav' : '']"
              @click="navgo('about')"
              v-if = "this.isEn != '1'"
              >关于我们</a
            >
            <a
              :class="['nav-link', $route.path == '/about' ? 'active-nav' : '']"
              @click="navgo('about')"
              v-if = "this.isEn == '1'"
            >About Us</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="[
                'nav-link',
                $route.path == '/ServicePlatform' ? 'active-nav' : '',
              ]"
              @click="navgo('ServicePlatform')"
              v-if = "this.isEn != '1'"
              >服务平台</a
            >
            <!--<a
              :class="[
                'nav-link',
                $route.path == '/ServicePlatform' ? 'active-nav' : '',
              ]"
              @click="navgo('ServicePlatform')"
              v-if = "this.isEn == '1'"
            >Service Platform</a
            >-->
          </li>
          <li class="nav-item" v-show="userInfoEntity != ''">
            <a
              :class="[
                'nav-link',
                $route.path == '/developmenter' ? 'active-nav' : '',
              ]"
              @click="navgo('developmenter')"
              v-if = "this.isEn != '1'"
              >开发者</a
            >
            <a
              :class="[
                'nav-link',
                $route.path == '/developmenter' ? 'active-nav' : '',
              ]"
              @click="navgo('developmenter')"
              v-if = "this.isEn == '1'"
            >kaifazhe</a
            >
          </li>
        </ul>
        <!-- <div class="loginBTN">
            <div class="" @click="openLogin()" v-if="userInfoEntity==''"> 登录 </div>
            <el-popover
              v-else
              popper-class="haslogin"
              placement="bottom"
              width="210px"
              trigger="hover">
              <div class="list-content">
                  <div class="list-item" @click="goOut"> 退出 </div>
              </div>
              <div slot="reference">您好，{{userInfoEntity.userInfoEntity.userName}}</div>
            </el-popover>
        </div> -->
        <div class="changeLanguage clearfix">
          <div
            class="cnLanguage"
            @click="changeLanguage('0')"
            :style="{ opacity: setlanguage == '0' ? '1' : '0.65' }"
          >
            中文
          </div>
          <!-- <div class="lineLanguage">|</div> -->
          <div
            class="enLanguage"
            @click="changeLanguage('1')"
            :style="{ opacity: setlanguage == '1' ? '1' : '0.65' }"
          >
            EN
          </div>
        </div>
      </div>
      <div
        class="hover-menu"
        v-show="windowSIZE.screenWidth > 990"
        :style="{
          'max-height': show_hoverMenu,
          'border-bottom': show_hoverMenu == 0 ? 'none' : '1px solid #ddd',
        }"
        @mouseover="Mover(true)"
        @mouseleave="Mout('transition')"
      >
        <div class="row" style="border-top: 1px solid #eaeaea">
          <div class="col-md-4 open-left-nav">
            <div>
              <div
                v-for="item in product_listData"
                @mouseover="chose_product_list(item)"
                :class="[
                  'product-list',
                  chose_product.uuid == item.uuid ? 'chosed' : '',
                ]"
              >
                {{ item.productName }}
                <!-- <span v-if="item.isnew" class="is-New"> NEW </span> -->
              </div>
            </div>
          </div>
          <div class="col-md-6 open-right-nav">
            <div
              v-for="item in chose_product.childProductList"
              class="col-md-3"
              @click="go_product_info(item.webModel, item.uuid)"
            >
              <img
                :src="item.productUrl"
                :alt="item.productName"
                class="product-img"
              />
              <div>{{ item.productName }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 过渡包 -->
    </nav>

    <!-- 移动 -->
    <nav
      :class="['navbar', 'navbar-expand-lg', comClass, viewScroll_status]"
      class="visible-sm-and-down"
    >
      <a class="navbar-brand hidden-sm-and-down" @click="navgo('home')">
        <img
          class="login-img"
          :src="
            '/static/link/img/home/' +
            (comClass == 'BCnav' || windowSIZE.screenWidth < 1000
              ? 'logo2_img.png'
              : 'logo1_img.png')
          "
          alt="德卡logo"
        />
        <!-- <span></span> -->
      </a>
      <a class="navbar-brand visible-sm-and-down" @click="navgo('home')">
        <img
          class="login-img"
          :src="
            '/static/link/img/home/' +
            (comClass == 'BCnav' || windowSIZE.screenWidth < 1000
              ? 'logo2_img.png'
              : 'logo1_img.png')
          "
          alt="德卡logo"
        />
        <!-- <span></span> -->
      </a>
      <button @click="changestatus" class="navbar-toggler" type="button">
        <span
          class="el-icon-menu"
          v-if="!mobileListShow"
          style="color: #212121; font-size: 20px"
        ></span>
        <!-- <Icon type="navicon" v-if="!mobileListShow"></Icon> -->
        <span
          class="el-icon-close"
          v-if="mobileListShow"
          style="color: #212121; font-size: 20px"
        ></span>
      </button>

      <div class="navbarSupportedContent" v-show="mobileListShow">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a
              :class="['nav-link', $route.path == '/' ? 'active-nav' : '']"
              @click="navgo('home')"
              v-if = "this.isEn != '1'"
            >
              首页
            </a>
            <a
              :class="['nav-link', $route.path == '/' ? 'active-nav' : '']"
              @click="navgo('home')"
              v-if = "this.isEn == '1'"
            >
              Home Page
            </a>
          </li>
          <li
            class="nav-item"
            style="position: relative"
            @click="navPhonego(windowSIZE.screenWidth)"
            @mouseover="Mover"
            @mouseleave="Mout"
          >
            <a
              :class="[
                'nav-link',
                $route.path == '/mobileProductList/1' ||
                $route.path == '/mobileProductList/2'
                  ? 'active-nav'
                  : '',
              ]"
              v-if = "this.isEn != '1'"
              >产品与方案</a
            >
            <a
              :class="[
                'nav-link',
                $route.path == '/mobileProductList/1' ||
                $route.path == '/mobileProductList/2'
                  ? 'active-nav'
                  : '',
              ]"
              v-if = "this.isEn == '1'"
            >Products and Solutions</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="[
                'nav-link',
                $route.path == '/service' ? 'active-nav' : '',
              ]"
              @click="navgo('service')"
              v-if = "this.isEn != '1'"
              >服务支持</a
            >
            <a
              :class="[
                'nav-link',
                $route.path == '/service' ? 'active-nav' : '',
              ]"
              @click="navgo('service')"
              v-if = "this.isEn == '1'"
            >Services and Supports</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="['nav-link', $route.path == '/news' ? 'active-nav' : '']"
              @click="navgo('news')"
              v-if = "this.isEn != '1'"
              >新闻动态</a
            >
            <a
              :class="['nav-link', $route.path == '/news' ? 'active-nav' : '']"
              @click="navgo('news')"
              v-if = "this.isEn == '1'"
            >News and Trends</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="['nav-link', $route.path == '/about' ? 'active-nav' : '']"
              @click="navgo('about')"
              v-if = "this.isEn != '1'"
              >关于我们</a
            >
            <a
              :class="['nav-link', $route.path == '/about' ? 'active-nav' : '']"
              @click="navgo('about')"
              v-if = "this.isEn == '1'"
            >About Us</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="[
                'nav-link',
                $route.path == '/ServicePlatform' ? 'active-nav' : '',
              ]"
              @click="navgo('ServicePlatform')"
              v-if = "this.isEn != '1'"
              >服务平台</a
            >
            <a
              :class="[
                'nav-link',
                $route.path == '/ServicePlatform' ? 'active-nav' : '',
              ]"
              @click="navgo('ServicePlatform')"
              v-if = "this.isEn == '1'"
            >Service Platform</a
            >
          </li>
        </ul>
      </div>
      <!-- <div
        class="hover-menu"
        v-if="windowSIZE.screenWidth > 990"
        :style="{
          'max-height': show_hoverMenu,
          'border-bottom': show_hoverMenu == 0 ? 'none' : '1px solid #ddd',
        }"
        @mouseover="Mover(true)"
        @mouseleave="Mout('transition')"
      >
        <div class="row" style="border-top: 1px solid #eaeaea">
          <div class="col-md-4 open-left-nav">
            <div>
              <div
                v-for="item in product_list"
                @mouseover="chose_product_list(item)"
                :class="[
                  'product-list',
                  chose_product.label == item.label ? 'chosed' : '',
                ]"
              >
                {{ item.label }}
                <span v-if="item.isnew" class="is-New"> NEW </span>
              </div>
            </div>
          </div>
          <div class="col-md-6 open-right-nav">
            <div
              v-for="item in chose_product.children"
              class="col-md-3"
              @click="go_product_info(item.type, item.value)"
            >
              <img :src="item.img" :alt="item.label" class="product-img" />
              <div>{{ item.label }}</div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 过渡包 -->
    </nav>

    <login-model ref="loginCom"></login-model>
  </div>
</template>

<script scope>
// import { productList } from "@/views/productList.js";
import loginModel from "@/components/loginModel";

import Bus from "../Bus.js";
export default {
  name: "HomeHeard",
  components: {
    // productList
    loginModel,
  },
  data() {
    return {
      mobileListShow: false,
      //logoStatus:"logo1_img.png", //logo2_img.png
      window_height: "",
      chose_product: "",
      navMenuShow: true,
      searchValue: "",
      searchCloseShow: false,
      // product_list: productList,
      product_listData: "",
      product_children: [],
      show_hoverMenu: 0,
      hoverStatus: false,
      scroll_value: 0,
      viewScroll: 0,
      windowSIZE: {
        screenWidth: document.documentElement.clientWidth,
        screenHeight: document.documentElement.clientHeight,
      },
      userInfoEntity: "",
      setlanguage: "0",
      defaultPro: "init",
      isEn:"",
      website_en_url:'',
    };
  },
  methods: {
    changestatus() {
      this.mobileListShow = !this.mobileListShow;
    },
    navgo(target) {
      this.mobileListShow = false;

      $("#navbarSupportedContent").removeClass("show");
      if (target == "product") {
        this.hoverStatus = false;
        this.show_hoverMenu = "0";
      }
      if (target == 'home') {
          let item = sessionStorage.getItem('isEn');
          if (item == '1') {
              target = '/en'
              this.$router.push({
                  path: target,
              });
              return;
          }
      }
      this.$router.push({
        name: target,
      });
    },
    navPhonego(v) {
      this.mobileListShow = false;
      $("#navbarSupportedContent").removeClass("show");
      if (v < 991) {
        this.$router.push(`/mobileProductList/2`);
      } else {
        if (this.defaultPro === "init") {
          return;
        } else if (this.defaultPro === false) {
          return;
        } else {
          this.$router.push(`/mobileScene/${this.defaultPro.industryType}`);
        }
      }
    },
    getDefaultPro() {
      let isEn = ('1' == sessionStorage.getItem("isEn") ? '1':'0');
      //获取行业方案列表，确定第一个行业为pc产品与方案默认菜单地址
      axios
        .get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/industry/list?isEn=`+isEn)
        .then((response) => {
          //console.log(response)
          var res = response.data;
          if (res.code === 200) {
            var prolist = res.data;
            if (prolist.length > 0) {
              this.defaultPro = prolist[0];
            } else {
              this.defaultPro = false;
            }
          } else {
            this.$message.error(res.msg ? res.msg : "请求有误，请稍后重试");
            this.defaultPro = false;
          }
        });
    },
    initTreeByWebsite() {
      let isEn = ('1' == sessionStorage.getItem("isEn") ? '1':'0');
      axios
        .get(
          `${window.$server_config.VUE_APP_WEBSITE_API}outer/product/initTree?isEn=`+isEn
        )
        .then((response) => {
          //console.log(response)
          var res = response.data;
          if (res.code === 200) {
            this.product_listData = res.data;
            if (this.product_listData.length > 0) {
              this.chose_product_list(this.product_listData[0]);
            }
          } else {
            this.$message.error(res.msg ? res.msg : "请求有误，请稍后重试");
          }
        });
    },
    handleScroll() {
      this.scroll_value = $(window).scrollTop();
    },

    Mover(status, event) {
      if (status) {
        this.hoverStatus = true;
        this.show_hoverMenu = "550px";
      } else {
        setTimeout(() => {
          this.hoverStatus = true;
          this.show_hoverMenu = "550px";
        }, 300);
      }
    },
    Mout(status, event) {
      this.show_hoverMenu = "0";
      this.hoverStatus = false;
    },
    // alongIn(){
    //   console.log("alongIn")
    //   this.show_hoverMenu = "550px";
    //   this.hoverStatus = true;
    // },

    //搜索
    search() {
      this.navMenuShow = false;
      this.searchCloseShow = true;
    },
    // searchKeyPress(e) {
    //   e = e || window.event;
    //   if (e.keyCode == "13" && this.searchValue != "") {
    //     this.$router.push({
    //       name: "searchProduction",
    //       params: { searchValue: this.searchValue },
    //     });
    //   }
    // },

    //搜索清除
    clearSearch() {
      this.searchValue = "";
      this.navMenuShow = true;
      this.searchCloseShow = false;
    },

    chose_product_list(data) {
      this.chose_product = data;
    },
    //详情跳转
    go_product_info(type, id) {
      this.show_hoverMenu = "0";
      this.hoverStatus = false;
      this.$router.push(`/productinfo${type}/${id}`);
    },
    cancel: function () {
      this.viewScroll = 0;
    },
    changeLanguage(lan) {
      this.setlanguage = lan;
      sessionStorage.setItem("isEn",lan);
      if (lan == "0") {
          this.$router.push({
              name: 'home',
          });
        location.reload();
      } else {
        //window.open(this.website_en_url);
        window.location.href = this.website_en_url;
        /*this.$router.push({
          path: '/en',
        });*/
      }
    },
    openLogin() {
      this.$refs.loginCom.openModel();
    },
    goOut() {
      this.$confirm("确定退出登录吗？", "退出确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "",
        showClose: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        center: true,
        confirmButtonClass: "dc-confirm-popup cancel-color btn90",
        cancelButtonClass: "confirmText-cancel-btn btn90",
      })
        .then(() => {
          this.logOut();
        })
        .catch(() => {});
    },

    logOut() {
      axios
        .post(
          `${window.$server_config.VUE_APP_WEBSITE_API}api/userInfoEntity/logout`,
          {}
        )
        .then((res) => {
          // if(res.data.code== 200||res.data.code=="12095010"){
          mercyStore.CLEARuserInfoEntity();
          let arr = ["AITerminal_token", "password"];
          arr.forEach((item) => {
            localStorage.removeItem(item);
          });
          this.userInfoEntity = "";
          if (this.$route.name == "developmenter") {
            this.$route.push("/");
          }
          // this.$message({
          //     message: '退出成功！',
          //     type: 'success'
          // });
          // }else {
          //     this.$message.error(res.data.msg)
          // }
        })
        .catch((res) => {
          mercyStore.CLEARuserInfoEntity();
          let arr = ["AITerminal_token", "password"];
          arr.forEach((item) => {
            localStorage.removeItem(item);
          });
          this.userInfoEntity = "";
          if (this.$route.name == "developmenter") {
            this.$router.push("/");
          }
        });
    },
  },
  created() {
    this.getDefaultPro();
    this.initTreeByWebsite();
    this.isEn = sessionStorage.getItem('isEn')  == '1' ?  '1' : '0';
  },
  mounted() {
    let that = this;
    // 监听滚动值
    this.height = $(window).height() - 70;
    window.addEventListener("scroll", this.handleScroll);
    this.mobileListShow = false;

    // 设置默认选择的右侧菜单
    // this.chose_product = this.product_list[0];
    //设置默认样式
    window.onresize = function () {
      // 定义窗口大小变更通知事件
      that.windowSIZE.screenWidth = document.documentElement.clientWidth; //窗口宽度
      that.windowSIZE.screenHeight = document.documentElement.clientHeight; //窗口高度
    };


    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.cancel, false);
    }

    this.setlanguage =  sessionStorage.getItem("isEn");
    if (mercyStore.GETuserInfoEntity()) {
      this.userInfoEntity = mercyStore.GETuserInfoEntity();
    }
    Bus.$on("changeUserEntity", (data) => {
      console.log(mercyStore.GETuserInfoEntity());
      this.userInfoEntity = mercyStore.GETuserInfoEntity();
    });
    axios
      .get(
        `${window.$server_config.VUE_APP_WEBSITE_API}outer/config/configKey/website_en_url`
      )
      .then((response) => {
        var res = response.data;
        if (res.code == 200) {
          this.website_en_url = res.data;
          console.log("url", this.website_en_url);
        } else {
          // this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updated() {
    let _that = this;
    $(".router-view").scroll(function () {
      if (
        _that.$route.path == "/service" ||
        _that.$route.path == "/about" ||
        _that.$route.path == "/ServicePlatform"
      ) {
        _that.viewScroll = $(".router-view").scrollTop();
      }
    });
  },
  computed: {
    comClass() {
      if (this.hoverStatus == true) {
        return "BCnav";
      }
      // if(this.$route.path=='/'){
      if (
        this.$route.path == "/" ||
        this.$route.path == "/service" ||
        this.$route.path == "/news" ||
        this.$route.path == "/about" ||
        this.$route.path == "/ServicePlatform" ||
        this.$route.path =='/en'
      ) {
        // if(this.height>this.scroll_value||!this.height){

        if (this.scroll_value == 0) {
          return "TCnav";
        }
        if (this.$route.path == "/news") {
          if (
            this.scroll_value >= $(".news-page").height() - 65 ||
            !this.height
          ) {
            return "BCnav";
          } else {
            return "TCnav";
          }
        } else if (this.$route.path == "/experience") {
          return "BCnav";
        }
        // if(this.scroll_value>=$().height()|| !this.height){
        //   return "BCnav"
        // }else{
        //   return "TCnav"
        // }

        if (
          this.scroll_value >= $(".home-main-title").height() ||
          !this.height
        ) {
          return "BCnav";
        } else {
          return "TCnav";
        }
      } else {
        return "BCnav";
      }
    },
    viewScroll_status() {
      if (
        this.viewScroll >= $(".first-page").height() - 50 &&
        this.windowSIZE.screenWidth > 991
      ) {
        return "hide-nav";
      } else {
        return "nav-mystyle";
      }
    },
  },
  watch: {
    "$route.path": function (newVal, oldVal) {
      if (newVal != "/") {
        // debugger
        this.viewScroll = 0;
        // if(this.windowSIZE.screenWidth>991){
        //   Bus.$emit('change_window_height','');
        // }
      }
    },
  },
  destroyed() {
    window.removeEventListener("popstate", this.cancel, false);
  },
};
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.nav-link {
  font-size: 16px;
  cursor: pointer;
  color: #fff;
  transition: all 0.3s ease;
}
.nav-item {
  height: 100%;
}
.nav-mystyle {
  /* background: #333; */
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
  color: #fff;
  padding-bottom: 0;
  /* transform:translateY(0px);
    -webkit-transform:translateY(0px);
    transition: all .2s linear;
    -webkit-transform: all .2s linear; */
  /* border-bottom: 0.1px solid; */
}
.navbar-brand {
  margin-left: 3%;
  cursor: pointer;
  position: absolute;
}
.navbar-toggler {
  position: absolute;
  right: 0;
  z-index: 1;
}
.hide-nav {
  max-height: 0px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0;
  /* transform:translateY(-64px);
    transition: all .3s linear;
    -webkit-transform:translateY(-64px);
    -webkit-transition: all .3s linear; */
  border-bottom: 1px solid #ddd;
}
.login-img {
  width: 203px;
  height: 32px;
  display: inline-block;
}
#navbarSupportedContent {
  text-align: center;
  /* margin-left: -25px; */
  height: 65px;
  line-height: 65px;
}
.navbar-nav {
  /* margin-left: calc(50% - 29.1rem); */
  margin: 0 auto;
}
.hover-menu {
  /* display: none; */
  color: #333;
  position: absolute;
  width: 100%;
  /* max-height: 0px; */
  max-height: 550px;
  top: 64px;
  /* top:0px; */
  /* padding-top: 65px; */
  left: 0;
  /* border-bottom: 1px solid #ddd; */
  transition: all 0.2s ease;
  overflow: hidden;
  height: 530px;
}
/* .hover-menu-row{
    width: 100%;
    height: 64px;
    background:transparent;
  } */
.hover-menu .row {
  height: 100%;
  background: #fff;
}
.hover-menu .open-left-nav {
  border-right: 1px solid #eaeaea;
  padding-right: 0px;
}
.hover-menu .open-left-nav > div {
  float: right;
  width: 250px;
  padding-top: 15px;
}
.hover-menu .open-left-nav > div > div {
  text-align: left;
  font-size: 16px;
}
.product-list {
  height: 50px;
  line-height: 50px;
  padding-left: 10px;
}
.chosed {
  background: #3bbde7;
  color: #fff;
}
.product-list .is-New {
  color: #fff;
  display: inline-block;
  margin-top: 2px;
  height: 20px;
  line-height: 14px;
  text-align: center;
  background: #ff5151;
  border-radius: 10px;
  font-size: 10px;
  margin-left: -2px;
  padding: 2px 8px;
  transform: scale(0.7);
  vertical-align: text-top;
}
.product-list:hover {
  background: #3bbde7;
  color: #fff;
}
.hover-menu .open-right-nav {
  padding: 30px;
  height: 500px;
  overflow: auto;
}
.hover-menu .open-right-nav > div {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  margin-bottom: 10px;
  height: 150px;
  float: left;
  font-size: 14px;
  color: #131313;
}
.loginBTN {
  position: relative;
  right: 85px;
  cursor: pointer;
  font-size: 14px;
}
/* .hover-menu .open-right-nav>div:hover{ */
/* animation: hoverLR 0.2s; */
/* transform: scale(1.01) */
/* } */
@keyframes hoverLR {
  0% {
    transform: translate(0px, 0px);
  }
  25% {
    transform: translate(-2px, 0px);
  }
  50% {
    transform: translate(0px, 0px);
  }
  75% {
    transform: translate(2px, 0px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
.open-right-nav .product-img {
  width: 100px;
  height: 100px;
  margin-bottom: 10px;
}
.nav-option {
  color: #fff;
  float: right;
}
.nav-search {
  float: left;
  width: 300px;
}
.seach-input {
  width: 100%;
}
.header-mask {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0px;
  height: 64px;
  background: #fff;
  z-index: -1;
  /* transition: all .2s ease; */
}

/*  响应式样式 */
.BCnav {
  /* transition: all .2s ease; */
  background: #fff;
  color: #333;
  z-index: 5;
  height: 65px;
  /* box-shadow: 0px 14px 14px -20px #5E5E5E; */
  border-bottom: 1px solid #ebebeb;
  padding-top: 0px;
}
.nav-link {
  color: #fff;
  opacity: 0.7;
}
.nav-link:hover {
  color: #fff;
  opacity: 1;
}
.TCnav {
  /* transition: all .2s ease; */
  background: transparent;
  color: #fff;
  z-index: 5;
  height: 65px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.TCnav .active-nav {
  color: #fff !important;
  opacity: 1;
}
.BCnav .active-nav {
  color: #3bbde7 !important;
  opacity: 1;
}
.BCnav .changeLanguage {
  position: absolute;
  right: 30px;
  color: #000;
}
.BCnav .cnLanguage {
  float: left;
  padding-right: 12px;
  cursor: pointer;
  font-size: 13px;
}
.BCnav .lineLanguage {
  float: left;
}
.BCnav .enLanguage {
  float: left;
  cursor: pointer;
  font-size: 15px;
}
.TCnav .changeLanguage {
  position: absolute;
  right: 30px;
  color: #fff;
}
.TCnav .cnLanguage {
  float: left;
  padding-right: 12px;
  cursor: pointer;
  font-size: 13px;
}
.TCnav .lineLanguage {
  float: left;
}
.TCnav .enLanguage {
  float: left;
  cursor: pointer;
  font-size: 15px;
}
/* .cnLanguage:hover,.enLanguage:hover{
  opacity: 0.9 !important;
} */

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .navbar-brand {
    position: relative;
  }
}
@media only screen and (max-width: 991px) {
  .navbar {
    z-index: 999999;
  }
  .TCnav {
    height: 50px;
    line-height: 50px;
    border-bottom: 0.5px solid #eaeaea;
  }
  .BCnav {
    border-bottom: 0.5px solid #eaeaea;
    height: 50px;
    line-height: 50px;
  }
  .TCnav .active-nav {
    color: #3bbde7 !important;
  }
  .navbar-brand {
    margin-left: 0%;
    height: 50px;
    line-height: 34px;
  }
  /* .active-nav{
    color: #202020 !important;
    background: #F8F9F9 !important;
  } */
  li {
    margin: 0;
    padding: 0;
  }
  .TCnav {
    background: #fff;
    color: #333;
  }
  .nav-link {
    width: 100%;
    padding-left: 10% !important;
    display: block;
  }
  .mr-auto {
    margin: 0;
    text-align: left;
  }
  .navbarSupportedContent {
    width: 100%;
    background: #fff;
    position: absolute;
    left: 0;
    top: 50px;
    box-shadow: 0px 2px 8px -2px rgba(0, 0, 0, 0.08);
  }
  .login-img {
    width: 45%;
    height: auto;
  }
  .navbar-toggler {
    height: 50px;
    right: 5px;
  }
}
.haslogin {
  background: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
  padding: 0px !important;
}
/* .list-content  */
.list-content .list-item {
  cursor: pointer;
  /* padding: 12px; */
}
.list-content .list-item:hover {
  color: #3bbde7;
}
.btn90 {
  width: 120px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeHeard.vue